import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue';
import CardsDashboard from './cards/Dashboard';
import CardsDashboardFree from './cards/Dashboard_free';
import CardsPush from './cards/Push';
import CardsCardDesign from './cards/Card_design';
import CardsFormDesign from './cards/Form_design';
import CardsSettings from './cards/Settings';
import CardsSettingsFree from './cards/Settings_free';
import CardsRegistrations from './cards/Registrations';
import CardsFAQ from './cards/FAQ';
import CardsDeadCards from './cards/DeadCards';
import CardsCards from './cards/Cards';
import CardsBlacklist from './cards/Blacklist';

import Account from './Account/index';
import AccountNewPosAuth from './Account/new_pos_auth';

import SF_results from './SMSFeedback/results';
import SF_settings from './SMSFeedback/settings';

import FindGuest from './FindGuest/index';

import GuestStore from './GuestStore/index';

import Pay from './Pay';

import Marketplace from './Marketplace';

import Main from './Main';

import AdminUsers from './Admin/Users';
import AdminTransactions from './Admin/Transactions';
import AdminStyle from './Admin/Style';
import AdminAddMoney from './Admin/AddMoney';
import AdminContracts from './Admin/Contracts';
import AdminCardsCerts from './Admin/CardsCerts';
import AdminChangePassword from './Admin/ChangePassword';

import ChatConnectChat from './ChatConnect/chat';
import ChatConnectSettings from './ChatConnect/settings';

import TelegramManager from './TelegramManager';

import SLStats from './SL/Stats';
import SLSettings from './SL/Settings';

import QR from './QR';

import InventoryWarehouses from './Inventory/warehouses';
import InventorySuppliers from './Inventory/suppliers';
import InventoryEmployee from './Inventory/employee';
import InventoryWarehouse from './Inventory/warehouse';
import InventoryWarehouseSetup from './Inventory/warehouse_setup';

export default {
  path: '',
  component: DashboardLayout,
  redirect: '/main/',

  children: [
    {
      path: 'main',
      name: 'main',
      component: Main,
      meta: {
        auth: true,
      },
    },
    {
      path: 'cards/dashboard',
      name: 'cards/dashboard',
      component: CardsDashboard,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'cards/dashboard_free',
      name: 'cards/dashboard_free',
      component: CardsDashboardFree,
      meta: {
        auth: true,
        service_id: 5,
      },
    },
    {
      path: 'cards/card_design',
      name: 'cards/card_design',
      component: CardsCardDesign,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'cards/dead_cards',
      name: 'cards/dead_cards',
      component: CardsDeadCards,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'cards/blacklist',
      name: 'cards/blacklist',
      component: CardsBlacklist,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'cards/cards',
      name: 'cards/cards',
      component: CardsCards,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'cards/registrations',
      name: 'cards/registrations',
      component: CardsRegistrations,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'cards/form_design',
      name: 'cards/form_design',
      component: CardsFormDesign,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'cards/settings',
      name: 'cards/settings',
      component: CardsSettings,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'cards/faq',
      name: 'cards/faq',
      component: CardsFAQ,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'cards/faq_free',
      name: 'cards/faq_free',
      component: CardsFAQ,
      meta: {
        auth: true,
        service_id: 5,
      },
    },
    {
      path: 'cards/settings_free',
      name: 'cards/settings_free',
      component: CardsSettingsFree,
      meta: {
        auth: true,
        service_id: 5,
      },
    },
    {
      path: 'cards/push',
      name: 'cards/push',
      component: CardsPush,
      meta: {
        auth: true,
        service_id: 1,
      },
    },
    {
      path: 'sms_feedback/results',
      name: 'sms_feedback/results',
      component: SF_results,
      meta: {
        auth: true,
        service_id: 2,
      },
    },
    {
      path: 'sms_feedback/settings',
      name: 'sms_feedback/settings',
      component: SF_settings,
      meta: {
        auth: true,
        service_id: 2,
      },
    },
    {
      path: 'inventory/warehouses',
      name: 'Склады',
      component: InventoryWarehouses,
      meta: {
        auth: true,
        service_id: 11,
        breadcrumb: {
          label: 'Склады',
        },
      },
    },
    {
      path: 'inventory/suppliers',
      name: 'Поставщики',
      component: InventorySuppliers,
      meta: {
        auth: true,
        service_id: 11,
        breadcrumb: {
          label: 'Поставщики',
        },
      },
    },
    {
      path: 'inventory/warehouses/:id',
      component: InventoryWarehouse,
      name: 'Информация о складе',
      meta: {
        breadcrumb: {
          label: 'Информация о складе',
          parent: 'Склады',
        },
      },
    },
    {
      path: 'inventory/warehouses/:id/setup',
      component: InventoryWarehouseSetup,
      name: 'Настройка склада',
      meta: {
        breadcrumb: {
          label: 'Настройка склада',
          parent: 'Информация о складе',
        }
      }
    },
    {
      path: 'inventory/employee',
      name: 'inventory/employee',
      component: InventoryEmployee,
      meta: {
        auth: true,
        service_id: 11,
      },
    },
    {
      path: 'findguest',
      name: 'findguest',
      component: FindGuest,
      meta: {
        auth: true,
        service_id: 3,
      },
    },
    {
      path: 'gueststore',
      name: 'gueststore',
      component: GuestStore,
      meta: {
        auth: true,
        service_id: 4,
      },
    },
    {
      path: 'pay',
      name: 'pay',
      component: Pay,
      meta: {
        auth: true,
      },
    },
    {
      path: 'account',
      name: 'account',
      component: Account,
      meta: {
        auth: true,
      },
    },
    {
      path: 'account/new_pos_auth',
      name: 'account/new_pos_auth',
      component: AccountNewPosAuth,
      meta: {
        auth: true,
      },
    },
    {
      path: 'marketplace',
      name: 'marketplace',
      component: Marketplace,
      meta: {
        auth: true,
      },
    },
    {
      path: 'admin/users',
      name: 'admin/users',
      component: AdminUsers,
      meta: {
        auth: true,
        user_type: [1],
      },
    },
    {
      path: 'admin/transactions',
      name: 'admin/transactions',
      component: AdminTransactions,
      meta: {
        auth: true,
        user_type: [1],
      },
    },
    {
      path: 'admin/styles',
      name: 'admin/styles',
      component: AdminStyle,
      meta: {
        auth: true,
        user_type: [1],
      },
    },
    {
      path: 'admin/addmoney',
      name: 'admin/addmoney',
      component: AdminAddMoney,
      meta: {
        auth: true,
        only_for_users: [2],
      },
    },
    {
      path: 'admin/contracts',
      name: 'admin/contracts',
      component: AdminContracts,
      meta: {
        auth: true,
        only_for_users: [2],
      },
    },
    {
      component: AdminCardsCerts,
      path: 'admin/cardsCerts',
      name: 'admin/cardsCerts',
      meta: {
        auth: true,
      },
    },
    {
      component: AdminChangePassword,
      path: 'admin/change_password',
      name: 'admin/change_password',
      meta: {
        auth: true,
      },
    },
    {
      path: 'chatconnect/chat',
      name: 'chatconnect/chat',
      component: ChatConnectChat,
      meta: {
        auth: true,
      },
    },
    {
      path: 'chatconnect/settings',
      name: 'chatconnect/settings',
      component: ChatConnectSettings,
      meta: {
        auth: true,
      },
    },
    {
      path: 'telegram_manager',
      name: 'telegram_manager',
      component: TelegramManager,
      meta: {
        auth: true,
        service_id: 10,
      },
    },
    {
      path: 'sl/stats',
      name: 'sl/stats',
      component: SLStats,
      meta: {
        auth: true,
        service_id: 8,
      },
    },
    {
      path: 'sl/settings',
      name: 'sl/settings',
      component: SLSettings,
      meta: {
        auth: true,
        service_id: 8,
      },
    },
    {
      path: 'qr',
      name: 'qr',
      component: QR,
      meta: {
        auth: true,
        service_id: 7,
      },
    },
  ],
};
